module.exports = __webpack_public_path__ + "img/ban3-en.9af48f43.svg";